var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',_vm._b({attrs:{"fluid":""}},'b-container',_vm.$attrs,false),[_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner')],1),_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('strong',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }